import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import UpcomingReleases from "./components/UpcomingReleases";
import NewReleases from "./components/NewReleases";
import CalendarPage from "./pages/calendarpage";
import Footer from "./components/Footer";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import SignupForm from './components/SignupForm';
import ProfileDashboard from "./pages/ProfileDashboard";
import LoginForm from './components/LoginForm';
import MyGames from './pages/MyGames';

import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA_ID);

function HomePage() {
  return (
    <>
      <HeroSection />
      <NewReleases />
      <UpcomingReleases />
    </>
  );
}

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      <Helmet>
        <meta httpEquiv="Content-Security-Policy" content="
          default-src 'self';
          script-src 'self' 'unsafe-inline' 
            https://www.googletagmanager.com 
            https://*.google-analytics.com 
            https://*.adtrafficquality.google 
            https://*.doubleclick.net 
            https://pagead2.googlesyndication.com 
            https://*.googlesyndication.com;
          style-src 'self' 'unsafe-inline';
          img-src 'self' data: https:;
          connect-src 'self' 
            https://www.google-analytics.com 
            https://*.google-analytics.com 
            https://*.adtrafficquality.google 
            https://*.doubleclick.net
            https://pagead2.googlesyndication.com
            https://*.googlesyndication.com;
          frame-src 'self' 
            https://*.google-analytics.com 
            https://*.adtrafficquality.google 
            https://*.doubleclick.net 
            https://www.google.com 
            https://www.youtube.com 
            https://youtube.com
            https://pagead2.googlesyndication.com
            https://*.googlesyndication.com;
        " />
        <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
        <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
        <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
      </Helmet>
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsofUse" element={<TermsofUse />} />
          <Route path="/Signup" element={<SignupForm />} />
          <Route path="/profile" element={<ProfileDashboard />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/my-games" element={<MyGames />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
